import { atom } from "jotai";
import { ImportJobStatus } from "./import";

export type ImportJobInfo = {
  jobId: string;
  serviceJobId: string;
  name?: string;
  productCount?: number;
};

export type ImportState = {
  /** Active import job. Set by useImportJob.startJob, cleared by ImportPoller on completion. */
  currentJob?: ImportJobInfo;
  /** Latest poll result for the active job. Updated by ImportPoller. */
  jobStatus?: ImportJobStatus;
  /** Snapshot of the most recently completed job, used to show "last import" UI. */
  lastJobStatus?: ImportJobStatus;
  /** Set to true when ImportPoller has performed at least one initial check (used by lastJobStatus consumers). */
  checked?: boolean;
};

export const importAtom = atom<ImportState>({});
